import { Dropdown, DropdownProps } from "primereact/dropdown";
import { instantQuotationSelector, setSelectedLocation } from "../../features/instantQuotationSlice";
import { Trans, useTranslation } from "react-i18next";
import React from "react";
import { LocationData } from "./InstantQuotation";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";

export function LocationDropdown() {
    const {locations, selectedLocation} = useAppSelector(instantQuotationSelector);
    const { t } = useTranslation("locale");
    const dispatch = useAppDispatch();

    const valueTemplate = (_option: LocationData, props: DropdownProps) => {
        if (!props.value) {
            return <span>{props.placeholder}</span>;
        }

        return itemTemplate(props.value);
    }

    const itemTemplate = (option: LocationData) => {
        return <div>
            <img src={`${process.env.REACT_APP_CONFIGURATION_BUCKET_ENDPOINT}/flags/${option.Code}.svg`} alt={`${option.Code}`} className={"thumbnail"}/>
            {option.SearchField}
        </div>
    }


    return <div className="field grid mb-3" data-cy="location-dropdown-container">
        <label className='col-12 mb-2 md:col-3 md:mb-0' data-cy="location-dropdown-label">{t('instantQuotation.location')}</label>
        <div className="col-12 md:col-9 flex justify-content-end" data-cy="location-dropdown-wrapper">
            <Dropdown
                value={selectedLocation}
                onChange={(e) => dispatch(setSelectedLocation(e.value))}
                options={locations}
                optionLabel="SearchField"
                filter
                showClear
                virtualScrollerOptions={{ itemSize: 38 }}
                itemTemplate={itemTemplate}
                valueTemplate={valueTemplate}
                placeholder={t('instantQuotation.selectALocation')}
                emptyFilterMessage={<Trans
                    i18nKey={"instantQuotation.empty"}
                    components={[
                        <a content="Mail link for Idwal Enquiries" className="summary-link"
                           key="contact-us" href="mailto:enquiries@idwalmarine.com" />]
                    }
                />}
                className={'dropdownContainer'}               
            />
        </div>
    </div>
}
